import React from 'react'
import useWindowWidth from '../../../utils/use.window.width'
import BreadcrumbsComponent from '../breadcrumbs.component'
import * as styled from './styled'

interface IBreadcrumb {
	title: string
	path: string
}

interface HeadingComponentProps {
	breadcrumbs: IBreadcrumb[]
	title: React.ReactNode
	description?: string
}

export const HeadingComponent: React.FC<HeadingComponentProps> = ({
	breadcrumbs,
	title,
	description,
}) => {
	const windowWidth = useWindowWidth()
	const isMobile = windowWidth <= 530

	return (
		<styled.HeadingWrapper>
			{!isMobile && <BreadcrumbsComponent breadcrumbs={breadcrumbs} />}
			<styled.HeadingContainer>
				<styled.HeadingTitle>{title}</styled.HeadingTitle>
				{description && <styled.HeadingText>{description}</styled.HeadingText>}
			</styled.HeadingContainer>
		</styled.HeadingWrapper>
	)
}
